/**
 * Check if the current route is a patient/client page
 * @param {Object} route - Vue Router route object
 * @returns {Boolean} - True if on a patient page
 */
export function isPatientRoute(route) {
  if (!route || !route.path) return false;

  // Match /clients/:id and any sub-routes
  const patientRoutePattern = /^\/clients\/\d+/;
  return patientRoutePattern.test(route.path);
}

/**
 * Extract patient ID from route
 * @param {Object} route - Vue Router route object
 * @returns {String|null} - Patient ID or null
 */
export function getPatientIdFromRoute(route) {
  if (!route || !route.params) return null;
  return route.params.id || null;
}

/**
 * Generate simple placeholder based on patient
 * @param {Object} patient - Patient object from Vuex store
 * @returns {String} - Placeholder text
 */
export function getPatientPlaceholder(patient) {
  if (!patient) return "Ask anything...";

  const firstName = patient.first || patient.user?.first;
  const lastName = patient.last || patient.user?.last;

  let patientName = "";
  if (firstName) {
    patientName = lastName ? `${firstName} ${lastName}` : firstName;
  }

  return patientName ? `Ask about ${patientName}...` : "Ask anything...";
}
